import React from 'react';
import styled from 'styled-components';

import PropTypes from 'prop-types';

const LogoContainer = styled.div`
    max-width: 125px;
    max-height: ${props => (props.isSmall ? 24 : 60)}px;
    flex: 0 0 60px;
    margin-bottom: ${props => props.marginBottom || '1.375em'};
    cursor: pointer;
`;

const Logo = styled.img`
    max-width: 125px;
    max-height: ${props => (props.isSmall ? 24 : 60)}px;
`;

const PartnerLogo = props => (
    <LogoContainer marginBottom={props.marginBottom} isSmall={props.isSmall || false}>
        <Logo
            src={props.logoUrl}
            onClick={props.onClick}
            isSmall={props.isSmall || false}
        />
    </LogoContainer>
);

PartnerLogo.propTypes = {
    logoUrl: PropTypes.string.isRequired,
    marginBottom: PropTypes.string,
    onClick: PropTypes.func,
    isSmall: PropTypes.bool
};

export default PartnerLogo;



// WEBPACK FOOTER //
// ./src/components/Donation/PartnerLogo.jsx